// extracted by mini-css-extract-plugin
export default {"widget":"TurnstileWidget_widget__DCTtj","statusMessage":"TurnstileWidget_statusMessage__AG2ms"};